<template>
  <v-flex>
    <client-form
      v-model="showForm"
      v-if="showForm"
      :client-id="selectedClient"
      @close="onFormSave"
      @save="onFormSave"
    />
    <azure-storage
      :id="azureStorageClientId"
      prefix="client"
      :value="fileUploaderOpen"
      @success="refreshGrid"
      @input="fileUploaderOpen = $event"
    />

    <section v-show="!showForm">
      <page-toolbar>
        <kendo-button icon="add" title="Add new" @click="addRecord" v-if="addNew"> </kendo-button>
        <v-switch v-model="showActive" :label="`Show Inactive`" @change="refreshGrid"></v-switch>
      </page-toolbar>
      <kendo-grid
        height="calc(100vh - 160px)"
        ref="clientGrid"
        :filterable="true"
        :sortable="true"
        :editable="!isReadOnly && 'inline'"
        @edit="onEdit"
        :dataSource="dataSource"
        :columns="columns"
        :pageable="true"
      ></kendo-grid>
    </section>
  </v-flex>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import PageToolbar from '@/components/PageToolbar'
import AzureStorage from '@/components/AzureStorage'
import {readOnlyEditor} from '@/helpers/kendo-editors'
import {mapGetters} from 'vuex'
import ClientForm from './ClientForm.vue'
import security from '@/mixins/security'
import confirmationWindow from '@/helpers/confirmation-window'
import {getDataItem} from '@/helpers/kendo-helpers'
import notification from '@/helpers/notification'
import {createCheckboxColumn} from '@/helpers/kendo-editors'
import $ from '@/helpers/jquery-bridge'
import {enableExportExcel} from '@/helpers/export-helper'

const joinValues = (field, property) => di =>
  (di[field] || [])
    .map(function(el) {
      return el[property]
    })
    .join(', ')

export default {
  mixins: [security],
  mounted() {
    let grid = this.$refs.clientGrid.kendoWidget()
    document.body.addEventListener('click', this.azureStorageOpenClick, false)
    enableExportExcel(grid, '/api/config/client/exportGridToExcel', $('.page_toolbar-item'))
  },
  beforeDestroy() {
    document.body.removeEventListener('click', this.azureStorageOpenClick)
  },

  methods: {
    refreshGrid: function() {
      return this.dataSource.read()
    },
    addRecord() {
      this.selectedClient = -1
      this.showForm = true
    },
    onFormSave() {
      this.dataSource.read()
    },
    onEdit(e) {
      this.selectedClient = e.model.clientId
      this.showForm = true
      e.sender.cancelChanges()
    },
    azureStorageOpenClick({target}) {
      if (!/azureStorageOpen/.test(target.className)) return

      const dataItem = getDataItem(target)
      const clientId = dataItem.id

      this.azureStorageClientId = clientId
      Vue.nextTick(() => {
        this.fileUploaderOpen = true
      })
    },
  },
  computed: {
    ...mapGetters({selectedClientId: 'authentication/selectedClientId'}),
    ...mapGetters({defaultClientId: 'authentication/defaultClientId'}),
    ...mapGetters({clients: 'authentication/clients'}),
    ...mapGetters({tokenString: 'authentication/tokenString'}),
    ...mapGetters({role: 'authentication/currentRole'}),
    addNew() {
      return this.role == 'SuperAdmin'
    },
    columns() {
      return [
        {command: 'edit', title: '&nbsp;', width: 55, hidden: this.isReadOnly},
        createCheckboxColumn(
          $(this.$refs.clientGrid),
          'isActive',
          {title: 'Active', width: 100},
          true,
        ),
        {
          field: 'clientId',
          title: ' ',
          width: 80,
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align: center;'},
          template: function(dataItem) {
            if (dataItem.hasFiles) {
              return `<i class="fas fa-paperclip fa-lg azureStorageOpen"></i>`
            }
            //var id = dataItem.clientId
            return `<i class="fas fa-folder-open fa-lg azureStorageOpen"></i>`
            //return `<img src="${imageUrl}" style="max-height: 35px; max-width: 100px;"/>`
          },
          filterable: false,
        },
        {
          field: '',
          title: 'Logo',
          width: 160,
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align: center;'},
          template: function(dataItem) {
            const imageUrl = `/api/config/Client/getLogo?clientId=${
              dataItem.clientId
            }&ts=${new Date().getTime()}`

            return `<img src="${imageUrl}" style="max-height: 35px; max-width: 100px;"/>`
          },
        },
        {
          field: 'name',
          title: 'Name',
          width: 220,
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align: left;'},
        },
        {
          field: 'fiscalYearEndMonth',
          title: 'Fiscal Year End',
          width: 200,
          headerAttributes: {
            style:
              'overflow:visible; white-space: normal; text-align: center; font-size:12px; vertical-align:middle; font-weight: bold',
          },
          attributes: {style: 'text-align: left;'},
        },

        {
          field: 'historicalMonthsNb',
          title: 'Nb. Of Historial Months',
          width: 116,
          headerAttributes: {
            style:
              'overflow:visible; white-space: normal; text-align: center; font-size:12px; vertical-align:middle; font-weight: bold',
          },
          attributes: {style: 'text-align: left;'},
        },
        {
          field: 'timeZone',
          title: 'Time Zone',
          width: 200,
          headerAttributes: {style: 'text-align: center;'},
        },
        {
          field: 'Ccies',
          title: 'ccies',
          width: 200,
          attributes: {class: 'truncate-grid-column-text'},
          editor: readOnlyEditor,
          template: joinValues('ccies', 'ccy'),
          filterable: false,
          sortable: false,
        },
        {
          field: 'functionalCcy',
          title: 'Functional Ccy',
          width: 182,
          headerAttributes: {style: 'text-align: center;'},
        },
        {
          field: 'ccyPairs',
          title: 'Ccy Pairs',
          width: 200,
          attributes: {class: 'truncate-grid-column-text'},
          editor: readOnlyEditor,
          template: joinValues('ccyPairs', 'ccyPair'),
          filterable: false,
          sortable: false,
        },
        {
          field: 'counterparties',
          title: 'Counterparty/Broker',
          width: 200,
          attributes: {class: 'truncate-grid-column-text'},
          editor: readOnlyEditor,
          template: joinValues('counterparties', 'counterpartyName'),
          filterable: false,
          sortable: false,
        },
        {
          field: 'products',
          title: 'Products',
          width: 200,
          attributes: {class: 'truncate-grid-column-text'},
          editor: readOnlyEditor,
          template: joinValues('products', 'productCode'),
          filterable: false,
          sortable: false,
        },
        {
          field: 'creationDate',
          title: 'Creation Date',
          format: '{0:yyyy-MM-dd HH:mm:ss}',
          width: 156,
          editor: readOnlyEditor,
        },
        {
          command: [
            {
              name: 'customDelete',
              iconClass: 'k-icon k-i-delete',
              click: function(e) {
                const vm = this
                const {name, clientId} = getDataItem(e.target)
                if (clientId == 0) {
                  notification('Cannot delete Master client')
                  return
                }

                e.preventDefault()
                confirmationWindow.openConfirmationWindow(
                  `Delete "${name}" client?`,
                  `Are you sure you want to delete the client "${name}"?`,
                  () => {
                    confirmationWindow.openConfirmationWindow(
                      `Delete "${name}" client?`,
                      'This action cannot be undone, continue?',
                      async () => {
                        const deleteUrl = '/api/config/Client'
                        await axios.delete(deleteUrl, {params: {clientId}})
                        vm.dataSource.read()
                        await this.$store.dispatch('authentication/getNewAccessToken')
                        if (clientId == vm.selectedClientId) {
                          const [firstClient] = vm.clients
                          await this.$store.dispatch('authentication/setSelectedClientId', {
                            selectedClientId: firstClient.clientId,
                          })
                        }
                      },
                    )
                  },
                )
              }.bind(this),
            },
          ],
          width: 82,
          attributes: {style: 'text-align: center;'},
          hidden: this.isReadOnly,
        },
      ]
    },
  },
  data() {
    return {
      selectedClient: null,
      azureStorageClientId: 0,
      fileUploaderOpen: false,
      showForm: false,
      showActive: false,
      dataSource: new kendo.data.DataSource({
        type: 'aspnetmvc-ajax',
        serverPaging: true,
        serverFiltering: true,
        serverSorting: true,
        pageSize: 20,
        transport: {
          read: {
            url: '/api/config/Client',
            type: 'GET',
            data: () => ({showActive: this.showActive}),
            cache: false,
          },
          create: {url: '/api/config/Client', type: 'POST', cache: false},
          update: {url: '/api/config/Client', type: 'PUT', cache: false},
        },
        schema: {
          errors: 'errors',
          total: 'total',
          data: 'data',
          model: {
            id: 'clientId',
            fields: {
              clientId: {type: 'number', defaultValue: -1},
              name: {type: 'string', editable: true},
              fiscalYearEnd: {type: 'number', defaultValue: 12},
              fiscalYearEndMonth: {type: 'string', editable: true},
              ccies: {defaultValue: []},
              ccyPairs: {defaultValue: []},
              counterparties: {defaultValue: []},
              products: {defaultValue: []},
              address: {type: 'string', editable: true},
              phoneNumber: {type: 'string', editable: true},
              timeZone: {type: 'string', editable: false},
              email: {type: 'string', editable: true},
              functionalCcy: {type: 'string', editable: false},
              creationDate: {type: 'date', editable: false},
              canBeDeleted: {type: 'bool', defaultValue: true, editable: false},
            },
          },
        },
      }),
    }
  },
  components: {
    PageToolbar,
    AzureStorage,
    ClientForm,
  },
}
</script>
